import { MEDIA } from "../../constants/media";
import { Wand2, FileSearch, Target, Brain, PenLine, Sparkles } from "lucide-react";

const AI = [
  { icon: Wand2, title: "Gerador de anúncios", who: "Empresas",
    desc: "Três palavras-chave e a IA devolve título, descrição e requisitos prontos a publicar, em português de Portugal." },
  { icon: FileSearch, title: "Análise e otimização de CV", who: "Candidatos",
    desc: "Compêtências detetadas, pontos fortes, palavras-chave em falta e sugestões de melhoria personalizadas para as vagas disponíveis." },
  { icon: Target, title: "Match Score", who: "Ambos",
    desc: "Pontuação 0-100 entre candidato e vaga, com resumo automático. Triagem em massa com um clique." },
  { icon: Brain, title: "Parse de CV para perfil", who: "Candidatos",
    desc: "Carrega o PDF e a IA preenche automática e instantaneamente o teu título profissional, habilidades e sobre mim." },
  { icon: PenLine, title: "Carta de Motivação", who: "Candidatos",
    desc: "Gera uma carta personalizada para cada candidatura, com base no teu CV e na descrição da vaga." },
  { icon: Sparkles, title: "Triagem em massa", who: "Empresas",
    desc: "Calcula o match de até 5 candidatos de uma vez e apresenta-os ordenados por compatibilidade." },
];

export const AiSection = () => (
  <section className="relative overflow-hidden bg-slate-950">
    <img src={MEDIA.abstractTech} alt="" aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover opacity-30" loading="lazy" />
    <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-950/85 to-sky-950/60" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-8 py-20">
      <div className="max-w-2xl mb-12">
        <p className="text-xs uppercase tracking-[0.2em] font-bold text-sky-400 mb-3">Inteligência artificial útil</p>
        <h2 className="font-heading font-black tracking-tighter text-3xl sm:text-4xl text-white">
          IA que trabalha, não que enfeita
        </h2>
        <p className="text-slate-400 mt-4">
          Seis usos concretos, disponíveis hoje na plataforma. Sem custos extra para candidatos.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="ai-section">
        {AI.map((a) => (
          <div key={a.title}
            className="rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm p-6 hover:border-sky-400/50 hover:bg-white/8 transition-all group">
            <div className="flex items-center justify-between mb-4">
              <div className="w-10 h-10 rounded-xl bg-sky-400/15 flex items-center justify-center group-hover:bg-sky-400/25 transition-colors">
                <a.icon className="w-5 h-5 text-sky-300" strokeWidth={1.75} />
              </div>
              <span className="text-[10px] uppercase tracking-[0.18em] font-bold text-slate-500 bg-white/5 px-2 py-0.5 rounded-full">{a.who}</span>
            </div>
            <h3 className="font-heading font-bold tracking-tighter text-base text-white">{a.title}</h3>
            <p className="text-sm text-slate-400 mt-2 leading-relaxed">{a.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
